import { Container, cn } from "@lumberset/ui";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Crumbs } from "../../components/crumbs";

/** The Help Center: articles, the assistant, and the ways to reach a person. */
export const Route = createFileRoute("/_app/help")({ component: HelpLayout });

const tab = cn(
  "txt-compact-small-plus transition-fg shrink-0 rounded-full px-3 py-1.5 text-ui-fg-subtle outline-none",
  "hover:text-ui-fg-base focus-visible:shadow-borders-focus",
  "aria-[current=page]:bg-ui-bg-base aria-[current=page]:text-ui-fg-base aria-[current=page]:shadow-elevation-card-rest",
);

function HelpLayout() {
  return (
    <>
      <Crumbs trail={[{ label: "Help" }]} />
      <Container className="bg-transparent p-0 shadow-none">
        <nav
          className="scrollbar-none flex items-center gap-x-1 overflow-x-auto p-0.5"
          aria-label="Help"
        >
          <Link to="/help" activeOptions={{ exact: true }} className={tab}>
            Articles
          </Link>
          <Link to="/help/ask" className={tab}>
            Ask
          </Link>
          <Link to="/help/contact" className={tab}>
            Contact
          </Link>
        </nav>
      </Container>
      <Outlet />
    </>
  );
}
